import { axiosRequest, type AxiosResult } from "@/lib/axios";
import type { FormPageAttribute } from "../types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export interface FormPageAttributeUpdateRequest {
	value: string;
}

export const formPageAttributeApi = {
	update: (workspaceId: string, formId: string, formPageId: string, attributeId: string, payload: FormPageAttributeUpdateRequest): Promise<AxiosResult<FormPageAttribute>> => {
		return axiosRequest({
			method: "PATCH",
			url: `${API_BASE_URL}/${workspaceId}/forms/${formId}/pages/${formPageId}/attributes/${attributeId}`,
			data: payload,
		});
	},
};
